export const WIDGET_SERVER_ENVIRONMENTS = {
  DRAFT: "draft",
  PREVIEW: "preview"
};

/**
 * Resolves which widget server the snippet should connect to.
 * The draft or preview widget server url is taken from the environment only,
 * so a branch deployer serves its own instances through its env vars.
 */
export const resolveWidgetServerUrl = ({ environment = WIDGET_SERVER_ENVIRONMENTS.PREVIEW } = {}) =>
  environment === WIDGET_SERVER_ENVIRONMENTS.DRAFT
    ? import.meta.env.VITE_DRAFT_WIDGET_SERVER_URL
    : import.meta.env.VITE_PREVIEW_WIDGET_SERVER_URL;
